import {getSelectedPlan, isSelectedPlan} from "../other/selected_plan.js";
import {addRegistrationEvent} from "../other/gtm_layer.js";
import {getRedirectTo, isRedirectTo} from "../other/redirect_to.js";
import showErrors from "../errors/showErrors.js";
import checkCaptcha from "../other/check_captcha.js";
import {getBackToUrl} from "../other/backto";

export default async function () {
    this.loading = true;

    try {
        const backToUrl = getBackToUrl();
        const isFreemiumSignup = ajax_var.redirect_to_service_name === ajax_var.hortisketch_service_name;

        let form_data = new FormData;
        form_data.append('re_token', await checkCaptcha());
        form_data.append('action', ajax_var.action_gs_signup);
        form_data.append('email', this.userData[this.current]['email'].value);
        form_data.append('fullName', this.userData[this.current]['fullName'].value);
        form_data.append('password', this.userData[this.current]['password'].value);
        form_data.append('username', this.userData[this.current]['username'].value);
        form_data.append('nonce', ajax_var.nonce);
        form_data.append('is_freemium_signup', isFreemiumSignup);

        const response = await axios.post(ajax_var.url, form_data);
        if (response?.data?.success !== true) {
            throw new Error(response);
        }

        let gtmEvent = getSelectedPlan();
        if (isFreemiumSignup) {
            gtmEvent = 'Freemium';
        } else if (backToUrl === ajax_var.community_domain) {
            gtmEvent = 'Community';
        }

        addRegistrationEvent(gtmEvent);

        if (isRedirectTo()) {
            window.location.href = getRedirectTo();
            return;
        }

        if (isSelectedPlan()) {
            window.location.href = "/?goToCheckout=1&selectedPlan=" + getSelectedPlan();
            return;
        }

        if (backToUrl) {
            window.location.href = backToUrl;
            return;
        }

        window.location.href = ajax_var.account_page_url;

    } catch (error) {
        showErrors.bind(this)('registration', error);
        this.loading = false;
    }
};
